export default __webpack_public_path__ + "static/media/c-zorba.06ef9b29.png";